import { GenericError } from './genericError.mjs';

class HttpCancelError extends GenericError {
    constructor(message, domain = 'httpApi') {
        super({ type: 'CancelError', domain, message });
        Object.setPrototypeOf(this, HttpCancelError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, HttpCancelError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}

export { HttpCancelError };
//# sourceMappingURL=httpCancelError.mjs.map
